import React from 'react';
import {
  Skeleton,
  SkeletonBlock,
  SkeletonContent,
  SkeletonLine,
} from '@one-thd/sui-atomic-components';

export const TopPOJobNameSkeleton = () => {
  return (
    <div>
      <SkeletonContent orientation="horizontal">
        <SkeletonContent initialSize="1/4" disablePadding>
          <SkeletonLine variant="heading" fullWidth />
        </SkeletonContent>
        <SkeletonContent initialSize="1/4" disablePadding />
        <SkeletonContent initialSize="1/4" disablePadding />
        <SkeletonContent initialSize="1/4" disablePadding>
          <SkeletonLine variant="heading" fullWidth />
        </SkeletonContent>
      </SkeletonContent>
      <SkeletonContent initialSize="full">
        <SkeletonLine numberOfLines={4} fullWidth />
      </SkeletonContent>
    </div>
  );
};

/**
 * Skeleton for the Spend By Department Section
 */
export const SpendByDepartmentSkeleton = () => {
  return (
    <div data-testid="skeleton-loader">
      <SkeletonContent orientation="horizontal">
        <SkeletonContent initialSize="1/4" disablePadding>
          <SkeletonLine variant="heading" fullWidth />
        </SkeletonContent>
        <SkeletonContent initialSize="1/4" disablePadding />
        <SkeletonContent initialSize="1/4" disablePadding />
        <SkeletonContent initialSize="1/4" disablePadding>
          <SkeletonLine variant="heading" fullWidth />
        </SkeletonContent>
      </SkeletonContent>
      <SkeletonContent initialSize="full">
        <SkeletonLine numberOfLines={4} fullWidth />
      </SkeletonContent>
    </div>
  );
};

export const SpendMapSkeleton = () => {
  return (
    <div className="sui-grid sui-grid-cols-1 md:sui-gird-cols-2 lg:sui-grid-cols-2">
      <div className="sui-col-span-1">
        <SkeletonContent initialSize="full">
          <SkeletonBlock aspect="wide" height={60} />
        </SkeletonContent>
      </div>
      <div className="sui-col-span-1">
        <Skeleton orientation="vertical" grow>
          <SkeletonContent>
            <SkeletonContent initialSize="full">
              <SkeletonLine numberOfLines={4} fullWidth />
            </SkeletonContent>
          </SkeletonContent>
        </Skeleton>
      </div>
    </div>
  );
};

export const TopItemSkeleton = () => {
  return (
    <div data-testid="top-item-skeleton">
      {Array.from({ length: 4 }, (_event, index) => (
        <div key={`top-item-skeleton-${index}`}>
          <SkeletonContent orientation="horizontal" disablePadding="x">
            <SkeletonContent>
              <SkeletonBlock
                aspect="square"
                height={20}
                width={20}
                data-testid="bt-skeleton-block"
              />
            </SkeletonContent>
            <SkeletonContent grow>
              <SkeletonLine fullWidth />
            </SkeletonContent>
          </SkeletonContent>
        </div>
      ))}
    </div>
  );
};
